<template>
  <div class="container">
    <van-tabs
      v-model="active"
      color="#1646C0"
      title-active-color="#1646C0"
      v-if="show"
      @click="onClick"
    >
      <van-tab title="待审核">
        <van-list
          v-model="listloading"
          :finished="listfinished"
          finished-text="没有更多啦"
          :immediate-check="false"
          @load="listload_more(1)"
          v-if="active == 0"
        >
          <div
            class="list"
            v-for="(item, index) in list"
            :key="index"
            @click="
              $router.push(
                '/checkdetail?id=' + item.id + '&org_id=' + item.org_id
              )
            "
          >
            <img :src="item.img" v-if="item.img" alt="" />
            <img src="static/img/icon3.png" v-else alt="" />
            <div class="center">
              <p class="title">{{ item.name }}</p>
              <p>组&emsp;&emsp;织：{{ item.org_name }}</p>
              <p>申请时间：{{ timeTrans(item.createtime) }}</p>
            </div>
            <div class="bt">审核</div>
          </div>
        </van-list>
      </van-tab>
      <van-tab title="审核通过">
        <van-list
          v-model="listloading"
          :finished="listfinished"
          finished-text="没有更多啦"
          :immediate-check="false"
          @load="listload_more(2)"
          v-if="active == 1"
        >
          <div class="list" v-for="(item, index) in list" :key="index">
            <img :src="item.img" v-if="item.img" alt="" />
            <img src="static/img/icon3.png" v-else alt="" />
            <div class="center">
              <p class="title">{{ item.name }}</p>
              <p>组&emsp;&emsp;织：{{ item.org_name }}</p>
              <p>申请时间：{{ timeTrans(item.createtime) }}</p>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
export default {
  name: "organizationcheck",
  data() {
    return {
      active: 0,
      show: false,
      list: [],
      listloading: false,
      listfinished: false,
      listpage: 1,
    };
  },
  mounted() {
    this.show = true;
    this.init(1);
  },
  methods: {
    onClick(name) {
      switch (name) {
        case 0:
          this.init(1);
          break;
        case 1:
          this.init(2);
          break;
        default:
          break;
      }
    },
    init(num) {
      this.list = [];
      this.listpage = 1;
      this.listloading = false;
      this.listfinished = false;
      this.$axios
        .post(
          "/api/org/org_member_list",
          this.qs.stringify({
            page: this.listpage,
            status: num,
          })
        )
        .then((res) => {
          //console.log(res.data);
          if (res.data.code != 0) {
            this.$toast(res.data.msg);
          } else {
            this.list = res.data.data.list;
          }
        });
    },
    listload_more(num) {
      this.listpage += 1;
      setTimeout(() => {
        this.$axios({
          method: "post",
          url: "/api/org/org_member_list",
          data: this.qs.stringify({
            page: this.listpage,
            status: num,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            this.list = this.list.concat(res.data.data.list);
          }
          this.listloading = false;
          if (res.data.data.list.length == 0) {
            //数据全部加载完成
            this.listfinished = true;
          } else {
            this.listfinished = false;
          }
        });
      }, 500);
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f5f6f7;
}
.list {
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin: 10px;
  display: flex;
}
.list img {
  width: 64px;
  height: 64px;
  border-radius: 8px;
}
.list .center {
  padding: 0 10px;
  line-height: 22px;
  font-size: 12px;
  color: #333;
}
.list .bt {
  color: white;
  background: #1646c0;
  border-radius: 14px;
  text-align: center;
  font-size: 12px;
  line-height: 28px;
  margin-left: auto;
  height: 28px;
  width: 54px;
  align-self: center;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/organizationcheck.vue